export default "__VITE_ASSET__677232ad__"